import React from "react";
import { BRAND } from "../../lib/constants";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="bg-ink text-white pt-20 pb-10"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-stone-800">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-12 h-12 bg-white grid place-items-center p-1.5">
                                <img
                                    src={BRAND.logo}
                                    alt="Momia logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <div>
                                <div className="font-cabinet font-bold text-xl tracking-tight leading-tight">
                                    {BRAND.name}
                                </div>
                                <a
                                    href={BRAND.websiteUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-400 hover:text-white transition-colors"
                                    data-testid="footer-website"
                                >
                                    {BRAND.website}
                                </a>
                            </div>
                        </div>
                        <p className="text-stone-400 text-base leading-relaxed max-w-md">
                            Global exporters of pharmaceuticals, AYUSH products,
                            cosmetics, hospital equipment and complete turnkey
                            hospital infrastructure.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500 mb-5">
                            Navigate
                        </div>
                        <ul className="space-y-3 text-sm text-stone-300">
                            <li>
                                <a
                                    href="#categories"
                                    className="hover:text-white transition-colors"
                                >
                                    Categories
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#services"
                                    className="hover:text-white transition-colors"
                                >
                                    Hospital Planning
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#inquiry"
                                    className="hover:text-white transition-colors"
                                >
                                    Request a Quote
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#meeting"
                                    className="hover:text-white transition-colors"
                                >
                                    Book a Meeting
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500 mb-5">
                            Direct Contact
                        </div>
                        <ul className="space-y-3 text-sm text-stone-300">
                            <li>
                                <a
                                    href={`https://wa.me/${BRAND.whatsapp.replace("+", "")}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors"
                                    data-testid="footer-whatsapp"
                                >
                                    WhatsApp · {BRAND.whatsappDisplay}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${BRAND.email}`}
                                    className="hover:text-white transition-colors"
                                    data-testid="footer-email"
                                >
                                    {BRAND.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BRAND.facebook}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors"
                                    data-testid="footer-facebook"
                                >
                                    Facebook · /YASHPALMOMIA
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 grid md:grid-cols-2 gap-6 border-t border-stone-800">
                    <div className="flex flex-col gap-2 text-xs font-mono uppercase tracking-[0.16em] text-stone-500">
                        <div className="flex flex-wrap gap-x-5 gap-y-1">
                            <span>
                                <span className="text-stone-600">Momia GST</span>{" "}
                                <span className="text-stone-300">{BRAND.legal.momiaGST}</span>
                            </span>
                            <span>
                                <span className="text-stone-600">CIN</span>{" "}
                                <span className="text-stone-300">{BRAND.legal.momiaCIN}</span>
                            </span>
                            <span>
                                <span className="text-stone-600">PAN</span>{" "}
                                <span className="text-stone-300">{BRAND.legal.momiaPAN}</span>
                            </span>
                        </div>
                        <div className="flex flex-wrap gap-x-5 gap-y-1">
                            <span>
                                <span className="text-stone-600">Adore Lifestyles GST</span>{" "}
                                <span className="text-stone-300">{BRAND.legal.adoreGST}</span>
                            </span>
                            <span>
                                <span className="text-stone-600">State</span>{" "}
                                <span className="text-stone-300">{BRAND.legal.state}</span>
                            </span>
                        </div>
                    </div>
                    <div className="md:text-right text-xs font-mono uppercase tracking-[0.16em] text-stone-500">
                        Registered under the Companies Act, 2013 · India
                    </div>
                </div>

                <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs font-mono uppercase tracking-[0.18em] text-stone-500">
                    <div>
                        © {year} {BRAND.name}. All rights reserved.
                    </div>
                    <div className="text-stone-600">
                        Export · Healthcare · Hospital Projects · PharmaOps SaaS
                    </div>
                </div>
            </div>
        </footer>
    );
}
